const _ = require('lodash')
import HelpIcon from "../../../components/HelpIcon"

/**
 * Gets last position of caret in text field
 * @param e the $event.target
 */
function getCarotPosition(e) {
  return (

    /* mozilla / dom 3.0 */
    ('selectionStart' in e && function() {
      var l = e.selectionEnd - e.selectionStart;
      return { start: e.selectionStart, end: e.selectionEnd, length: l, text: e.value.substr(e.selectionStart, l) };
    }) ||

    /* exploder */
    (document.selection && function() {

      e.focus();

      var r = document.selection.createRange();
      if (r === null) {
        return { start: 0, end: e.value.length, length: 0 }
      }

      var re = e.createTextRange();
      var rc = re.duplicate();
      re.moveToBookmark(r.getBookmark());
      rc.setEndPoint('EndToStart', re);

      return { start: rc.text.length, end: rc.text.length + r.text.length, length: r.text.length, text: r.text };
    }) ||

    /* browser not supported */
    function() {
      console.log("browser not supported")
      return null;
    }

  )();
}

function setSelectionRange(input, selectionStart, selectionEnd) {
  if (input.setSelectionRange) {
    input.focus();
    input.setSelectionRange(selectionStart, selectionEnd);
  }
  else if (input.createTextRange) {
    const range = input.createTextRange();
    range.collapse(true);
    range.moveEnd('character', selectionEnd);
    range.moveStart('character', selectionStart);
    range.select();
  }
}

function setCaretToPos (input, pos) {
  setSelectionRange(input, pos, pos);
}

angular.module('clientDashboardApp').controller('ReviewResponseTemplateCtrl', function($scope, $uibModal, confirmService, pagingService, reviewResponseTemplateService, $timeout) {

  $scope.loadingTemplates = true

  reviewResponseTemplateService.listTemplates().then((templates) => {
    $scope.responseTemplates = templates
    $scope.loadingTemplates = false
  })

  const deleteTemplate = (_id) => {
    reviewResponseTemplateService.deleteTemplate(_id.$oid)
    $scope.responseTemplates = _.filter($scope.responseTemplates, (template) =>  template._id != _id)
  }

  const refreshPagedTemplates = () => {
    $scope.responseTemplatesPaged = pagingService.createPagingData($scope.responseTemplates , 5, 'name');
    if(pagingService.getCurrentPage()){
      $scope.responseTemplatesPaged.currentPageNum = pagingService.getCurrentPage();
    }
  }

  $scope.updatePagingState = function(){
    pagingService.setCurrentPage($scope.responseTemplatesPaged.currentPageNum);
  }

  $scope.openEditModal = function(template) {
    $uibModal.open({
      template: require('./ReviewResponseTemplateFormModal.html'),
      scope: $scope,
      controller: ["$scope", ReviewResponseTemplateModalCtrl(template, onUpdateTemplate)],
      controllerAs: 'vm'
    })
  }

  $scope.displayDeleteConfirmation = function(_id) {
    confirmService.confirm("Remove review response template?", "This will make this review response template unavailable for use.", confirmService.DELETE)
    .then(confirmed => {
      if (confirmed) {
        deleteTemplate(_id)
      }
    })
  }

  function onUpdateTemplate(_id, name, body, sentimentType) {
    if (angular.isDefined(_id)){
      reviewResponseTemplateService.updateTemplate(_id.$oid, name, body, sentimentType)
      const template = _.find($scope.responseTemplates, (template) =>  template._id == _id)
      if (template) {
        template.name = name
        template.body = body
        template.reviewSentimentType = sentimentType
      }
    }
    else {
      reviewResponseTemplateService.createTemplate(name, body, sentimentType).then(template => {
        $scope.responseTemplates.push(template)
      })
    }
  }

  const ReviewResponseTemplateModalCtrl = (responseTemplate, onUpdate) => function ($scope) {
    const vm = this;
    vm.caretPos = {start: 0, end: 0}
    if (responseTemplate) {
      vm._id = responseTemplate._id
      vm.name = responseTemplate.name
      vm.body = responseTemplate.body
      vm.sentimentType = responseTemplate.reviewSentimentType
    }

    vm.updateCredential = () => {
      onUpdateTemplate(vm._id, vm.name, vm.body, vm.sentimentType)
      $scope.$close()
    }

    vm.visibleMergeCodes = [
      {id: 'customer_name', displayName: 'Customer Full Name'},
      {id: 'customer_first_name', displayName: 'Customer First Name'},
      {id: 'business_name', displayName: 'Business Name'},
      {id: 'business_phone_number', displayName: 'Business Phone Number'}
    ]

    vm.templateBodyKeyPress = function($event) {
      const target = $event.target
      $timeout(() => {
        // So we can let event propagation do its thing
        vm.caretPos = {start: target.selectionStart, end: target.selectionStart}
      })
    }

    vm.templateBodyClick = function($event) {
      vm.caretPos = getCarotPosition($event.target)
    }

    vm.addMergeCode = (mergeCode) => {
      const insert = "{{" + mergeCode + "}}"
      vm.body = [(vm.body || "").slice(0, vm.caretPos.end), insert, (vm.body || "").slice(vm.caretPos.end)].join('');
      $timeout(() => {
        // So we can let event propagation do its thing
        setCaretToPos(angular.element("textarea#body")[0], vm.caretPos.end + insert.length)
      })
    }
  }

  $scope.$watch('responseTemplates.length',function(newVal,oldVal) {
    if ($scope.responseTemplates) {
      refreshPagedTemplates();
    }
  });
})
